<template>
  <div class="home-msg" v-loading="loading">
    <div class="home-msg_title spaceBetween">
      Unread Messages
      <el-button type="text" @click="goToMore"
        >See more<i class="el-icon-d-arrow-right"
      /></el-button>
    </div>
    <el-collapse accordion class="home-msg_collapse" @change="changeOpen" v-model="activeCollapse">
      <el-collapse-item v-for="(item, index) in dataList" :key="index" :name="item.msgID" :class="{ 'is-readed': +item.status !== 0 }">
        <template slot="title">
          <div class="spaceBetween home-msg_collapse_head">
            <div>
              <svg-icon icon-class="tn-jiantou" class="icon-arrow" />
              <span>{{ item.title }}</span>
            </div>
            <span class="time-text">
              {{ moment(item.timestamp).fromNow() }}
            </span>
          </div>
        </template>
        <pre class="msg-desc">
          {{ item.description }}
        </pre>
      </el-collapse-item>
    </el-collapse>
    <div class="msg-empty" v-if="dataList.length == 0">No Data</div>
  </div>
</template>

<script>
import { readed } from "@/api/message.js";
export default {
  components: {},
  data() {
    return {
      dataList: [],
      loading: false,
      activeCollapse: undefined,
    };
  },
  computed: {},
  methods: {
    getDataList() {
      this.loading = true;
      this.$store.dispatch("GetMessageUnRead")
        .then(res => {
          this.dataList = res.result.list;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    changeOpen(data) {
      let item = this.dataList.find(i => i.msgID == this.activeCollapse);
      if (item && +item.status === 0) {
        readed({ msgID: this.activeCollapse }).then(res => {
          item.status = 1;
        });
      }
    },
    goToMore() {
      this.$router.push("/messages/index");
    }
  },
  created() {
    this.getDataList();
  }
};
</script>
<style scoped lang="scss">
.home-msg {
  margin-top: 0.32rem;
  background: #fff;
  border-radius: 4px;
  padding-bottom: 0.24rem;

  .home-msg_title {
    font-size: 0.22rem;
    color: #262626;
    padding: 0.24rem 0.32rem;
    font-weight: 500;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 4px;
  }
  .home-msg_collapse {
    padding: 0 0.32rem 0.24rem 0.32rem;
    border: none;
    ::v-deep .el-collapse-item__header {
      background: #fafafa !important;
      border-bottom: none;
      color: #000;
      font-weight: bold;
      font-size: 0.18rem;
      padding: 0.24rem 0.32rem;
      &.is-active {
        .icon-arrow {
          color: #666;
          transform: rotate(90deg);
          display: inline-block;
        }
      }
    }
    ::v-deep .el-collapse-item__content {
      background: #fafafa !important;
      border-bottom: none;
      font-size: 0.18rem;
      color: #575757;
      padding: 0 0.32rem 0.24rem 0.32rem;
    }
    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
    }
    .el-collapse-item {
      margin-bottom: 12px;
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
    .home-msg_collapse_head {
      width: 100%;
      .time-text {
        color: #a3a3a3;
        font-weight: normal;
      }
    }
    .is-readed {
      opacity: 0.6;
    }
  }
}
.msg-empty {
  color: #999;
  font-size: 0.18rem;
  text-align: center;
  padding: 0.24rem;
}
.msg-desc{
  font-size: 0.18rem;
  margin:0;
}
</style>
